import { Suspense } from "react";
import { graphql, usePaginationFragment } from "react-relay";

import { ItemList$key } from "../../../__generated__/ItemList.graphql";
import { extractNodes } from "../../../lib/utils/connection";
import Grid from "../../grid/Grid";

import ItemListItem from "./ItemListItem";

type CollectionItemListProps = {
  root: ItemList$key;
  className?: string;
};

const fragment = graphql`
  fragment ItemList on Collection
  @refetchable(queryName: "ItemListPaginationQuery")
  @argumentDefinitions(
    count: { type: "Int", defaultValue: 25 }
    cursor: { type: "String" }
  ) {
    items(first: $count, after: $cursor) @connection(key: "ItemList_items") {
      edges {
        cursor
        node {
          id
          ...ItemListItem
        }
      }
    }
  }
`;

function ItemList(props: CollectionItemListProps) {
  const { data } = usePaginationFragment(fragment, props.root);

  return (
    <Grid className={props.className}>
      {extractNodes(data.items).map((item) => (
        <Suspense key={item.id} fallback={<div />}>
          <ItemListItem item={item} />
        </Suspense>
      ))}
    </Grid>
  );
}

export default ItemList;
